import { Flex, Icon, Text } from '@/ui';
import type { IconName } from '@/ui/Icon/Icon';
import { SidebarIconChip } from '../SidebarKit';

type Props = {
  /** Trailing marker for a section needing attention, e.g. a paused source. */
  badge?: React.ReactNode;
  icon: IconName | React.ReactNode;
  isActive: boolean;
  label: string;
  onClick: () => void;
};

// Left-rail nav item for FullScreenPanel.
export const NavItem = ({ badge, icon, isActive, label, onClick }: Props) => (
  <Flex
    _hover={isActive ? undefined : { bg: 'rgba(0,0,0,0.03)' }}
    align="center"
    bg={isActive ? 'magicPurple.25' : undefined}
    borderRadius="ah-lg"
    cursor="pointer"
    gap={2.5}
    px={3}
    py={2}
    onClick={onClick}
  >
    <SidebarIconChip size="26px" variant={isActive ? 'purple' : 'neutral'}>
      {typeof icon === 'string' ? (
        <Icon
          color={isActive ? 'magicPurple.600' : 'ink.soft'}
          icon={icon as IconName}
          size={3.5}
        />
      ) : (
        icon
      )}
    </SidebarIconChip>
    <Text
      color={isActive ? 'magicPurple.700' : 'ink.strong'}
      fontSize="ah-control"
      fontWeight={isActive ? 600 : 500}
    >
      {label}
    </Text>
    {badge && <Flex ml="auto">{badge}</Flex>}
  </Flex>
);
